import { unauthenticatedClient } from './baseApi';

export type ApplicationPayload = {
  full_name: string;
  phone: string;
  id_number: string;
  email?: string;
  reason_for_joining?: string;
};

export type ApplicationResponse = {
  message: string;
  status: string;
  user_id: number;
  note?: string;
};

export type ApplicationStatusResponse = {
  full_name: string;
  status: string;
  date_applied: string;
  message: string;
  date_joined?: string | null;
};

export const ApplicationApi = {
  submitApplication: async (payload: ApplicationPayload): Promise<ApplicationResponse> => {
    const response = await unauthenticatedClient.post<ApplicationResponse>('/application/apply', payload);
    return response.data;
  },
  checkStatus: async (phone: string): Promise<ApplicationStatusResponse> => {
    const response = await unauthenticatedClient.get<ApplicationStatusResponse>(`/application/status/${phone}`);
    return response.data;
  },
};

export default ApplicationApi;

